import { useBaseStyles } from './useBaseStyles'
import { styled } from 'goober'
import { useTheme } from '../useTheme'
import { getPanelWidth } from '../../utils/helpers'
import { useBreakpoints } from '../useBreakpoints'

export const useNotificationCenterStyles = () => {
  const { P } = useBaseStyles()
  const theme = useTheme()
  const { lgUp, smUp } = useBreakpoints()

  return {
    NCHeaderContainer: styled('div')({
      display: 'flex',
      alignItems: 'center',
      width: 'auto',
      padding: '0 1rem',
      gap: '1rem',
      height: '60px',
      minHeight: '60px',
      maxHeight: '60px',
      flexShrink: 0
    }),

    NCHeaderTypographyMobile: styled(P)({
      fontSize: '20px',
      fontWeight: 500,
      color: theme?.palette.text?.main
    }),

    NCHeaderTypography: styled(P)({
      color: theme.palette.text.primary,
      fontSize: '0.7rem',
      marginLeft: '8px',
      fontWeight: 500
    }),

    NCHeaderStyles: styled('div')({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: `1px solid ${theme.palette.divider}`,
      flexShrink: 0,
      boxShadow:
        'rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px'
    }),

    NCHeaderOfflineContainerMobile: styled('div')({
      display: 'inline-flex',
      justifyContent: 'space-between',
      width: '100%'
    }),

    NCHeaderOfflineContainer: styled('div')(({ smUp }) => ({
      display: 'flex',
      alignItems: 'center',
      justifyContent: !smUp ? 'space-between' : 'center',
      width: 'auto',
      background: 'rgba(0,0,0,0.2)',
      borderTopRightRadius: '10px',
      borderTopLeftRadius: '10px'
    })),

    NotificationCenterContainer: styled('div')(
      ({ notificationCenterPosition, notificationCenterOffset }) => ({
        borderRadius: '10px',
        boxShadow:
          '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)',
        width: getPanelWidth(lgUp, smUp),
        backgroundColor: theme.palette.background.paper,
        boxSizing: 'border-box',
        position:
          notificationCenterPosition === 'left' ||
          notificationCenterPosition === 'right'
            ? 'fixed'
            : 'relative',
        ...(notificationCenterPosition === 'left' ||
        notificationCenterPosition === 'right'
          ? { top: 0 }
          : {}),
        ...(notificationCenterPosition === 'left'
          ? { left: notificationCenterOffset || '2rem' }
          : {}),
        ...(notificationCenterPosition === 'right'
          ? { right: notificationCenterOffset || '2rem' }
          : {})
      })
    ),

    NCMenuContainer: styled('div')({
      height: smUp ? '75vh' : '80vh',
      minHeight: smUp ? '75vh' : '80vh',
      maxHeight: smUp ? '75vh' : '80vh',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      background: 'transparent',
      borderRadius: '10px'
    })
  }
}
